/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseIdDocumentComparingData } from './get-trustdock-verifications200-response-id-document-comparing-data';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseIdDocumentRecordsInner } from './get-trustdock-verifications200-response-id-document-records-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseIdDocumentResult } from './get-trustdock-verifications200-response-id-document-result';

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseIdDocument
 */
export interface GetTrustdockVerifications200ResponseIdDocument {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'idForHelper': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'state': GetTrustdockVerifications200ResponseIdDocumentStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseIdDocumentResult}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'result': GetTrustdockVerifications200ResponseIdDocumentResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'acceptedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'plansSelectedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'documentSubmittedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'preparedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseIdDocumentComparingData}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'comparingData': GetTrustdockVerifications200ResponseIdDocumentComparingData;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseIdDocumentRecordsInner>}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'records': Array<GetTrustdockVerifications200ResponseIdDocumentRecordsInner> | null;
}

export const GetTrustdockVerifications200ResponseIdDocumentStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseIdDocumentStateEnum = typeof GetTrustdockVerifications200ResponseIdDocumentStateEnum[keyof typeof GetTrustdockVerifications200ResponseIdDocumentStateEnum];


